import React, {useEffect} from 'react'
import {Spin} from "antd";
import localStore from "../../Util/LocalStore";
import appConfig from "../../Config/App";

export const Logout = () => {

    useEffect(() => {
        localStore.removeItem('loginSession');
        localStore.removeItem('loggedUser');
        localStore.removeItem('tenant');

        // @ts-ignore
        window.location.href = `${appConfig.logoutUrl}`;
    }, [])


    return (
        <div className={'mg-t-10 mg-l-10'}>Đang chuyển trang, vui lòng đợi một chút.... <Spin/></div>
    );
}